<template>
  <!-- 园区看板-申请和授权趋势-折线图 -->
	<div ref="myChart" :style="{margin: '0 auto',width: '100%', height: '100%'}"></div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		props: {
			echartDatas: {
				type: Object,
				default() {
					return {}
				}
			}
		},
		components: {
		},
		created() {
		},
		mounted() {
			this.drawChart()
      // if (this.echartDatas.length > 0) {
      //   this.drawChart()
      // }
		},
		methods: {
			drawChart() {
        let echartDatas = this.echartDatas
        let xAxisDatas = []
        let seriesDatas1 = [] // 申请
        let seriesDatas2 = [] // 授权
        // if (echartDatas) {
        for (let i = echartDatas.ad_year.length - 1; i >= 0; i--) {
          xAxisDatas.push(echartDatas.ad_year[i].name)
          seriesDatas1.push(echartDatas.ad_year[i].count)
          seriesDatas2.push(echartDatas.gd_year[i].count)
        }
        // }
        let maxVal // 对比两个数组获取两个数组中的最大值
        let maxVal1 = seriesDatas1[0]
        for (let i = 0; i < seriesDatas1.length; i++) {
          if (maxVal1 < seriesDatas1[i]) { maxVal1 = seriesDatas1[i] }
        }
        let maxVal2 = seriesDatas2[0]
        for (let i = 0; i < seriesDatas2.length; i++) {
          if (maxVal2 < seriesDatas2[i]) { maxVal2 = seriesDatas2[i] }
        }
        if (maxVal1 >= maxVal2) {
          maxVal = maxVal1
        } else {
          maxVal = maxVal2
        }
				// this.$refs.myChart.removeAttribute("_echarts_instance_")
				// document.getElementById('echartLine').removeAttribute("_echarts_instance_");
				// 基于准备好的dom，初始化echarts实例
				let myChart = this.$echarts.init(this.$refs.myChart, 'light')
				// 指定图表的配置项和数据
				let option = {
					title: {
            text: '申请和授权趋势',
            x: 'center',
            y: 0,
            textStyle: {
            fontSize: 18,
            fontWeight: 'normal',
            color: '#ffffff'
            }
          },
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            left: '3%',
            right: '8%',
            bottom: '3%',
            containLabel: true
          },
          legend: {
            data: ['申请', '授权'],
            top: '10%',
            textStyle: {
              color: '#01C2F9', // 字体颜色 #cde6c7 #d1c7b7 #d9d6c3 #d3d7d4
              fontStyle: 'normal', // 文字字体的风格 'normal'标准 'italic'斜体 'oblique' 倾斜
              fontWeight: 'normal',
              fontFamily: 'sans-serif', // 文字的字体系列
              fontSize: 14
            }
          },
          xAxis: {
            type: 'category',
            maxInterval: 1,
            boundaryGap: false,
            axisLabel: {
              show: true,
              color: '#01C2F9',
              fontSize: 14
            },
            splitLine: {
              show: false
            },
            data: xAxisDatas
            // data: [
            //   2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022
            // ]
          },
          yAxis: {
            type: 'value',
            realtimeSort: true,
            boundaryGap: [0, '100%'],
            // max: 25000,
            max: maxVal,
            axisLabel: {
              show: true,
              color: '#01C2F9',
              fontSize: 14
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                color: '#D9D9D9',
                width: 0.4
              },
              splitNumber: 5
            }
          },
          series: [
            {
              type: 'line',
              stack: 'Total',
              name: '申请',
              label: {
                normal: {
                  show: true,
                  formatter: function (params) {
                    if (params.dataIndex % 2 == 0) {
                      return params.value
                    } else { return '' }
                  },
                  position: 'top',
                  distance: 1,
                  color: '#3fb2ee',
                  textStyle: {
                    color: "#ffffff",
                    fontStyle: "normal",
                    fontWeight: "normal",
                    fontFamily: "sans-serif",
                    fontSize: 12
                  }
                }
              },
              lineStyle: {
                color: '#3fb2ee'
              },
              animation: true,
              animationDuration: 5000,
              data: seriesDatas1
              // data: [
              //   34, 38, 38, 40, 38, 50, 48, 19, 67, 67, 58, 145, 458, 1923, 4975, 15481, 20678, 21746, 15664, 284
              // ]
            },
            {
              type: 'line',
              name: '授权',
              label: {
                show: false,
                color: '#ffd85c',
                textStyle: {
                  color: '#ffd85c',
                  fontStyle: 'normal',
                  fontWeight: 'normal',
                  fontFamily: 'sans-serif',
                  fontSize: 12
                }
              },
              lineStyle: {
                color: '#ffd85c'
              },
              animation: true,
              animationDuration: 5000,
              data: seriesDatas2
              // data: [
              //   20, 12, 9, 19, 18, 15, 30, 26, 27, 40, 35, 48, 58, 83, 185, 603, 1616, 5208, 9663, 2732
              // ]
            }
          ]
				}
				// 使用刚指定的配置项和数据显示图表。
				myChart.setOption(option)
			}
		},
		watch: {
			echartDatas: {
				handler() { // val, oldVal
					// console.log('当数量变化时重新绘制图表')//但是这两个值打印出来却都是一样的
					this.drawChart()
				}
			}
		}
	}
</script>

<style>
</style>
